<template>
  <DialogTemplate style="max-width: 72rem">
    <DragDropPicker
      class="tblcolpicker"
      :selected="l_selected"
      :options="options"
      :canDelete="canDelete"
      :emptySectedMessage="$t('tables_columns.empty_selected_message')"
      :emptyNotSectedMessage="$t('tables_columns.empty_notselected_message')"
      @update:selected="handleUpdate"
    >
      <template #selected_title>
        <div class="text-normal clr-white weight_600">
          {{ $t('tables_columns.selected_columns') }}
        </div>
        <div
          class="text-small clr-grey"
          v-html="
            $t(`tables_columns.selected_columns_sub`, {
              icon: `<span class='mdi mdi-trash-can-outline drgpicker_texticon drgpicker_texticon_encircled'></span>`,
              icon_drag: `<span class='mdi mdi-drag drgpicker_texticon drgpicker_texticon_encircled'></span>`,
            })
          "
        ></div>
      </template>
      <template #notselected_title>
        <div class="text-normal clr-white weight_600">
          {{ $t('tables_columns.selected_columns') }}
        </div>
        <div
          class="text-small clr-grey"
          v-html="
            $t(`tables_columns.selected_columns_sub`, {
              icon: `<span class='mdi mdi-trash-can-outline drgpicker_texticon drgpicker_texticon_encircled'></span>`,
              icon_drag: `<span class='mdi mdi-drag drgpicker_texticon drgpicker_texticon_encircled'></span>`,
            })
          "
        ></div>
      </template>
      <template #selected_item="{ item }">
        <div class="gw_box tblcolpicker_item">
          {{ $t(`table_head.${item.id}`) }}
        </div>
      </template>
      <template #notselected_item="{ item }">
        <div class="gw_box tblcolpicker_item">
          {{ $t(`table_head.${item.id}`) }}
        </div>
      </template>
      <template #shallowitem="{ item }">
        <div class="gw_box tblcolpicker_item">
          {{ item ? $t(`table_head.${item.id}`) : '' }}
        </div>
      </template>
    </DragDropPicker>
    <template #dialog_actions>
      <v-btn
        variant="text"
        @click="resetToDefault"
      >
        <i class="mr-2 mdi mdi-replay text-semi-large"></i>
        {{ $t('btn.reset_default') }}
      </v-btn>
      <v-btn
        id="trainer-settings-btn-close"
        variant="text"
        class="ml-auto mr-2"
        @click="close"
      >
        {{ $t('btn.close') }}
      </v-btn>
      <div
        v-if="!canConfirm"
        class="csst mt-auto"
      >
        <v-btn
          :disabled="true"
          color="primary"
        >
          {{ $t('btn.confirm') }}
        </v-btn>
        <div
          class="csst_content text-nowrap"
          style="top: -2rem; right: 0"
        >
          {{ $t('messages.tables_columns_minimum', { num: 3 }) }}
        </div>
      </div>
      <v-btn
        v-else
        color="primary"
        :disabled="!canConfirm"
        @click="apply"
      >
        {{ $t('btn.confirm') }}
      </v-btn>
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import DragDropPicker from '@/components/DragDropGrid/DragDropPicker'
import { defaultTablesColumns } from '@/store/userSettings/settingsDefaults'

export default {
  name: 'TableColumnsSettingsDialog',
  components: {
    DragDropPicker,
    DialogTemplate,
  },
  props: {
    dialog: Object,
  },
  data() {
    return {
      l_selected: [],
    }
  },
  created() {
    const cols = this.$store.getters.tablesColumns[this.dialog.table] || []
    console.log(this.$store.getters.tablesColumns)
    this.l_selected = cols.map(i => ({ id: i }))
  },
  methods: {
    handleUpdate(value) {
      this.l_selected = value
    },
    confirm() {
      this.$refs.form.apply()
      this.close()
    },
    apply() {
      if (!this.canConfirm) return
      this.updateSettings({
        ...this.$store.getters.tablesColumns,
        [this.table]: this.l_selected.map(i => i.id),
      })
    },
    resetToDefault() {
      this.updateSettings({
        ...this.$store.getters.tablesColumns,
        [this.table]: defaultTablesColumns()[this.dialog.table],
      })
    },
    updateSettings(patchData) {
      this.$store.dispatch('setSettingsValue', { key: 'tablesColumns', patchData })
      this.close()
    },
    close() {
      this.$store.dispatch('router_rm_dialog', 'table-columns-settings-dialog')
    },
  },

  computed: {
    options() {
      return defaultTablesColumns()[this.dialog.table].map(i => ({ id: i }))
    },
    canDelete() {
      return this.dialog.delete !== 'disabled'
    },
    table() {
      return this.dialog.table
    },
    canConfirm() {
      return this.l_selected.length >= 3
    },
  },
}
</script>

<style lang="scss" scoped>
.tblcolpicker {
  min-width: clamp(1px, 34rem, calc(100vw - 4rem));
  &_item {
    flex: 1;
    padding: 1rem 2rem 1rem 1rem;
    display: flex;
    overflow: hidden;
  }
}
</style>
